// Lazy load
export const lazyLoad = () => {
    const lazyImages = Array.from(document.querySelectorAll("img.lazy-loading"));
    const lazyVideos = Array.from(document.querySelectorAll("video.lazy-loading"));
    const options = {
                        root: document.querySelector('#smooth-wrapper'),
                        rootMargin: "500px"
                    }
    if ("IntersectionObserver" in window) {
        // Lazy loading for image
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        }, options);
    
        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });

        // Lazy loading for video
        const lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(video) {
                if (video.isIntersecting) {
                    for (let source in video.target.children) {
                        const videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                        videoSource.src = videoSource.dataset.src;
                        }
                    }
    
                    video.target.load();
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        }, options);

        lazyVideos.forEach(function(lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }
}